import { BackendRoute } from '../../config/index';
import { QueryKey } from '../../constants/index';
import { ApiService } from '../../services/index';
import { useAppMutation } from '../use-app-mutation.hook';

export const useCreateScenarioClassConversion = () => {
  const { mutate: createScenarioClassConversion, isPending } = useAppMutation(
    [QueryKey.CREATE_SCENARIO_CLASS_CONVERSION],
    {
      mutationFn: ({ scenarioId, conversionId }: { conversionId: string; scenarioId: string }) =>
        ApiService.post(
          {
            endpoint: BackendRoute.SCENARIOS,
            routePath: [scenarioId, 'scenario-class-conversions'],
          },
          {
            body: {
              conversionId,
            },
          },
        ),
    },
  );
  return { createScenarioClassConversion, isPending };
};
